export const formatApiErrorDetail = (detail) => {
  if (detail == null) return 'Bir hata oluştu. Lütfen tekrar deneyin.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((entry) => (entry && typeof entry.msg === 'string' ? entry.msg : JSON.stringify(entry)))
      .filter(Boolean)
      .join(' ');
  }
  if (typeof detail === 'object' && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};